import React from "react";
import SupportEmail from "../components/SupportEmail";

const Home = () => {
  return (
    <>
      <div className="home-container">
        <img src="/logo.png" alt="Omega Void Logo" className="logo" />
      </div>
      <SupportEmail />
    </>
  );
};

export default Home;